import { Constantes } from "../constants/constantsGlobal";

export const ChatbotCallApiForm = async (
  data: Record<string, any>
): Promise<any> => {
  try {
    const response = await fetch(Constantes.URI_ChatbotCallApiForm, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const contentType = response.headers.get("Content-Type") || "";
    if (contentType.includes("application/json")) {
      return await response.json();
    }

    return await response.text();
  } catch (error) {
    console.error(" Error:", error);
    throw error;
  }
};